import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/landing/Hero';
import { Hook } from '../components/landing/Hook';
import { Pain } from '../components/landing/Pain';
import { Trampa } from '../components/landing/Trampa';
import { PorQueFalla } from '../components/landing/PorQueFalla';
import { Mecanismo } from '../components/landing/Mecanismo';
import { QueIncluye } from '../components/landing/QueIncluye';
import { Bonos } from '../components/landing/Bonos';
import { ResumenValor } from '../components/landing/ResumenValor';
import { ParaQuien } from '../components/landing/ParaQuien';
import { ComoSeUsa } from '../components/landing/ComoSeUsa';
import { Urgencia } from '../components/landing/Urgencia';
import { Garantia } from '../components/landing/Garantia';
import { Precio } from '../components/landing/Precio';
import { CTAFinal } from '../components/landing/CTAFinal';
import { FAQ } from '../components/landing/FAQ';
import { Disclaimer } from '../components/landing/Disclaimer';
import { SaleNotification } from '../components/ui/SaleNotification';
export function LandingPage() {
  useEffect(() => {
    // Set page title and meta description
    document.title = 'Semana Resuelta — Tu semana de comida, resuelta.';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Menú + Lista + Swaps + Plan B — todo en un PDF descargable. Sin ingredientes raros. Sin calculadora. Descarga inmediata.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Menú + Lista + Swaps + Plan B — todo en un PDF descargable. Sin ingredientes raros. Sin calculadora. Descarga inmediata.';
      document.head.appendChild(meta);
    }
    // Initialize Meta Pixel and fire PageView
    const win = window as any;
    if (!win.fbq) {
      const fbq: any = function (...args: any[]) {
        fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
      };
      win.fbq = fbq;
      win._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    win.fbq('init', '1703383767307378');
    win.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-[#FDFCF8] font-sans text-stone-900 selection:bg-emerald-200 selection:text-emerald-900" data-id="element-327">
      <Hero data-id="element-328" />
      <Hook data-id="element-329" />
      <Pain data-id="element-330" />
      <Trampa data-id="element-331" />
      <PorQueFalla data-id="element-332" />
      <Mecanismo data-id="element-333" />
      <QueIncluye data-id="element-334" />
      <Bonos data-id="element-335" />
      <ResumenValor data-id="element-336" />
      <ParaQuien data-id="element-337" />
      <ComoSeUsa data-id="element-338" />
      <Urgencia data-id="element-339" />
      <Garantia data-id="element-340" />
      <Precio data-id="element-341" />
      <CTAFinal data-id="element-342" />
      <FAQ data-id="element-343" />
      <Disclaimer data-id="element-344" />
      <SaleNotification data-id="element-345" />
    </div>;
}